import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import { HandleGridBody } from "components/common/HandleGridBody.js";
import { DateFormatCell, formatDateForAPI, AmountFormatCellEmptyZeroNoPadding } from "components/common/formatter";
import { Checkbox, RadioGroup } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import SearchTextBox from "components/SearchComponent.jsx";
import { useNavigate } from "react-router-dom";
import styles from "../../pages/Matters/Matter.module.scss";
import {
  clearMattersBalances,
  getMattersAllURLInfo,
  getMyMattersPageList,
} from "actions/matters.action";
import ChitRequest from "pages/ChitRequest/ChitRequest";
import TimeRecordingHelper from "components/MyMatters/TimeRecordingHelper";
import { changeLedgerLink } from "actions/ledgerLinks.action";
import MatterForm from "pages/Matters/MatterForm";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { FilterComponent } from "components/common/FiltersComponent";
import { getMatterAllInfo } from "api";
import { useActiveDepartments } from "services/departmentService";
import { useActiveWorkTypes } from "services/workTypeService";
import { useActiveApplications } from "services/applicationService";
import MatterLedger from "pages/MatterLedger/MatterLedger";
import { Dialog } from "@progress/kendo-react-dialogs";
import { MatterOptionsList, MatterOptions } from "components/Matters/MatterOptions";
import { Popup } from "@progress/kendo-react-popup";
import { FaFilter } from "react-icons/fa";
import filtersAppliedIcon from "assets/CaseFileIcons/FilterApplied.svg";
import BillingRequestModal from "pages/Bills/BillingRequestModal";
import { getAccessRightsData, useCurrentUser } from "services/currentUserService";
import { SvgIcon } from "@progress/kendo-react-common";
import { GridLoader } from "components/GridLoader";
import { GRID_PAGE_SIZES } from "components/common/GridComponents";
import ActionbarSkelton from "components/common/Loaders/ActionbarSkelton";

const MyMattersPageComponent = ({ component, fromClient, Clientdata }) => {
  const menuWrapperRef = useRef(null);
  const date = new Date();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchRef = useRef();
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [chitRequestModal, setChitRequestModal] = useState(false);
  const [timeRecordingModal, setTimeRecordingModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const { data: user } = useCurrentUser();

  const [filterParameters, setFilterParameters] = useState(() => ({
    branch: -2,
    appCode: undefined,
    feeEarnerRef: user?.userRef,
    teamId: -2,
  }));
  const [showMatterForm, setshowMatterForm] = useState(false);
  const [loadedContent, setLoadedContent] = useState(true);
  const [selectedMatter, setSelectedMatter] = useState(null);
  const [allowAccessData, setAllowAccessData] = useState({});
  const [showBillingRequest, setShowBillingRequest] = useState(false);
  const [billingRequestMatter, setBillingRequestMatter] = useState();
  const [reference, setReference] = useState();
  const [matterLedger, selectMatterLedger] = useState(null);
  // Date picker state for myMattersPage case
  const [includeStartDate, setIncludeStartDate] = useState(false);
  const [includeEndDate, setIncludeEndDate] = useState(false);
  const [fromDateSelector, setFromDateSelector] = useState(date);
  const [toDateSelector, setToDateSelector] = useState(date);
  const [list, setLists] = useState(() => {
    if (fromClient && Clientdata) {
      return { data: Clientdata, total: Clientdata.length };
    }
    return { data: [], total: 50 };
  });
  const [status, setStatus] = useState("Open");
  const [application, setApplication] = useState("");
  const [department, setDepartment] = useState("");
  const [workType, setWorkType] = useState("");
  const [filtersPopup, setFiltersPopup] = useState(false);
  const filterAnchorRef = useRef(null);
  const filtersPopupRef = useRef(null);

  const reduxLoadingState = useSelector((state) => state?.mattersList.isLoading);

  // For child components (fromClient), don't use Redux loading state
  const [isLoadingMattersList, setIsLoadingMattersList] = useState(
    fromClient ? false : reduxLoadingState,
  );

  useEffect(() => {
    if (!fromClient) {
      setIsLoadingMattersList(reduxLoadingState);
    }
  }, [reduxLoadingState]);

  const { data: activeApplications, loading: isLoadingApplications } =
    useActiveApplications();

  const { data: departmentOptions } = useActiveDepartments();
  const [workTypeOptions, setWorkTypeOptions] = useState([]);
  const { data: allActiveWorkTypes } = useActiveWorkTypes();

  const [selectedCell, setSelectedCell] = useState(null);
  const [show, setShow] = useState(false);
  const offSet = useRef({ left: 0, top: 0 });
  const DEFAULT_SORT = [
    { field: "LastActionDateMe", dir: "desc" }
  ];

  const [dataState, setDataState] = useState({
    take: 100,
    skip: 0,
    sort: DEFAULT_SORT,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuWrapperRef.current && menuWrapperRef.current.contains(event.target))
        return;

      if (
        event.button !== 2 &&
        event.target?.role !== "menu-grid" &&
        event.target?.role !== "button"
      ) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!filtersPopup) return;

    const handlePointerDown = (event) => {
      const anchorElement = filterAnchorRef.current;
      if (anchorElement && anchorElement.contains(event.target)) {
        return;
      }

      const popupElement = filtersPopupRef.current;
      const popupContainer = popupElement
        ? popupElement.closest(".k-animation-container")
        : null;
      const rect =
        popupContainer?.getBoundingClientRect?.() ||
        popupElement?.getBoundingClientRect?.();

      if (!rect) {
        setFiltersPopup(false);
        return;
      }

      const { clientX, clientY } = event;
      const isInside =
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom;
      if (!isInside) {
        setFiltersPopup(false);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, [filtersPopup]);

  const handleOptionClick = (action, props) => {
    switch (action) {
      case "viewMatter":
        onMatterRefClickActions(props);
        break;
      case "casefile":
        navigate(`/matters/${props?.dataItem?.matterId || props?.matterId}`);
        break;
      case "addTime":
        setSelectedMatter(props?.dataItem || props);
        setTimeRecordingModal(true);
        break;
      case "addChitRequest":
        setSelectedMatter(props?.dataItem || props);
        setChitRequestModal(true);
        break;
      case "viewLedger":
        dispatch(changeLedgerLink("MatterLedger", props?.dataItem || props));
        selectMatterLedger(props?.dataItem || props);
        break;
      case "billingRequest":
        setShowBillingRequest(true);
        setBillingRequestMatter(props.dataItem || props);
        break;
      default:
        break;
    }
    setShow(false);
  };

  const mattersDataGetter = async (id) => {
    try {
      setIsLoading(true);
      const datas = await getMatterAllInfo(id);
      dispatch(getMattersAllURLInfo(datas, false));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      alert("No matter exists against this Id. Try again with different Id");
      navigate("/matters");
    }
  };

  const analyzeFilterParamters = (params) => {
    if (fromClient) return;
    if (!params) return; // don't wipe existing filters

    setFilterParameters((prev) => {
      const next = {
        ...prev,
        ...(params.branch !== undefined ? { branch: params.branch } : {}),
        ...(params.teamId !== undefined ? { teamId: params.teamId } : {}),
        ...(params.feeEarnerRef !== undefined
          ? { feeEarnerRef: params.feeEarnerRef }
          : {}),
      };

      // Avoid unnecessary state updates
      return JSON.stringify(next) === JSON.stringify(prev) ? prev : next;
    });
  };

  const onChangeFromDateSelect = (event) => {
    if (!includeStartDate) {
      setIncludeStartDate(true);
    }
    setFromDateSelector(event.value);
  };

  const onChangeToDateSelect = (event) => {
    if (!includeEndDate) {
      setIncludeEndDate(true);
    }
    setToDateSelector(event.value);
  };

  const builtFilterParameters = useMemo(() => {
    if (component === "myMattersPage") {
      return {
        feeEarnerRef: user?.userRef,
        search: searchValue || undefined,
        status: status || undefined,
        ...(includeStartDate && fromDateSelector
          ? { openFrom: formatDateForAPI(fromDateSelector) }
          : {}),
        ...(includeEndDate && toDateSelector
          ? { openTo: formatDateForAPI(toDateSelector) }
          : {}),
      };
    }
    return filterParameters;
  }, [
    component,
    user?.userRef,
    searchValue,
    status,
    includeStartDate,
    includeEndDate,
    fromDateSelector,
    toDateSelector,
    application,
    department,
    workType,
    filterParameters,
  ]);

  const getAccessRights = async () => {
    try {
      const data = await getAccessRightsData();
      setAllowAccessData(data?.data?.data);
      setLoadedContent(false);
    } catch (error) {}
  };

  useEffect(() => {
    if (!fromClient) {
      getAccessRights();
    }
  }, []);

  useEffect(() => {
    if (fromClient && Clientdata !== undefined) {
      // Data is provided directly, no loading needed
      setIsLoading(false);
      setIsLoadingMattersList(false);
      setLists({ data: Clientdata || [], total: Clientdata?.length || 0 });
    }
  }, [fromClient, Clientdata]);

  const onMatterRefClickActions = (props) => {
    // navigate(`/matters/${props.dataItem.matterId}`);
    setReference(props.dataItem?.matterRef || props.matterRef);
    mattersDataGetter(props.dataItem?.matterId || props.matterId);
    setshowMatterForm(true);
  };

  const MatterRefCell = (props) => {
    return (
      <td role="button">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            // onMatterRefClickActions(props);
            setShow(false);
            handleCellClick(null);

            try {
              window.chrome.webview.postMessage(
                "CasefileOpened:" + props.dataItem.matterId,
              );
            } catch (error) {}

            navigate(`/matters/${props.dataItem.matterId}`);
          }}>
          <u role="button">{props.dataItem.matterRef}</u>
        </span>
      </td>
    );
  };

  const MatterDetailCell = (props) => {
    const isClosed = (props.dataItem?.status || "").toLowerCase() === "closed";
    return (
      <td>
        <div className="d-flex justify-content-between align-items-center">
          <span className="text-start">
            {props.dataItem.details}

            {isClosed && (
              <span
                className={`d-inline-flex align-items-center gap-2 ms-2 ${styles["closed-banner"]}`}>
                <span className={styles["close-button"]} />
                <span className="fs-md fw-semibold">Closed</span>
              </span>
            )}
          </span>

          <span className="text-end fw-bold fs-sm">
            {!fromClient && " " + props.dataItem.clientName}
          </span>
        </div>
      </td>
    );
  };

  const createState = (skip, take) => {
    let pagerSettings = { pageSizes: GRID_PAGE_SIZES };
    return { pageSize: take, pageable: pagerSettings };
  };
  const [state, setState] = React.useState(createState(0, 10));

  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState?.sort?.[0] === undefined) {
      // if user clears sort, go back to default sort
      setDataState({
        ...e.dataState,
        sort: DEFAULT_SORT,
      });
    } else {
      setDataState(e.dataState);
    }
  };
  const dataReceived = (list) => {
    if (list.data) {
      setLists(list);
    }
  };

  const handleRefresh = () => {
    // reset to default sort whenever refresh is pressed
    setDataState((prev) => ({
      ...prev,
      skip: 0,
      sort: DEFAULT_SORT,
    }));
    setIsRefreshed(!isRefreshed);
  };

  useLayoutEffect(() => {
    return () => {
      dispatch(getMyMattersPageList());
    };
  }, []);

  const handleCheckboxChange = (newStatus) => {
    setStatus(newStatus);
  };

  const handleSearchChange = (value) => {
    const nextValue = value ?? "";
    setSearchValue(nextValue);
    setFilterParameters((prev) => ({ ...prev, search: nextValue || undefined }));
    setDataState((prev) => ({ ...prev, skip: 0 }));
  };

  const handleReset = () => {
    setStatus("Open");
    setApplication(null);
    setDepartment(null);
    setWorkType(null);
    setWorkTypeOptions([]);
    setFilterParameters((prev) => {
      const updated = { ...prev };
      delete updated.appCode;
      delete updated.departmentId;
      delete updated.workTypeId;
      return updated;
    });
  };

  useEffect(() => {
    if (department?.departmentID) {
      const filtered = (allActiveWorkTypes || []).filter(
        (wt) => wt.departmentId === department.departmentID,
      );
      setWorkTypeOptions(filtered);
    } else {
      setWorkTypeOptions([]);
    }
    setWorkType(null);
  }, [department?.departmentID, allActiveWorkTypes]);

  useEffect(() => {
    if (component !== "myMattersPage") {
      setFilterParameters((prev) => ({
        ...prev,
        appCode: application?.appCode || undefined,
        departmentId: department?.departmentID || undefined,
        workTypeId: workType?.workTypeID || undefined,
      }));
    }
  }, [application?.appCode, department?.departmentID, workType?.workTypeID]);

  const getHeaderItems = () => {
    switch (component) {
      case "matters":
        return loadedContent ? (
          <ActionbarSkelton />
        ) : (
          <div className="d-flex align-items-end flex-wrap gap-2 mb-3 justify-content-start">
            <FilterComponent
              allowAccessData={allowAccessData}
              updateFilters={(data) => analyzeFilterParamters(data)}
              isRefreshed={isRefreshed}
              inlineLayout
            />

            <div style={{ flex: "1 1 0%", minWidth: "200px", maxWidth: "280px" }}>
              <SearchTextBox
                ref={searchRef}
                changeFilterValue={handleSearchChange}
                width="100%"
                height="40px"
              />
            </div>

            <Button
              className={`${styles["refresh-icon"]} common-btn me-auto`}
              onClick={handleRefresh}
              type="button"
              title="Refresh">
              <span className="d-flex align-items-center">
                <SvgIcon icon={refreshIcon} />
                <span className={`ms-1 ${styles["refresh-label-icon-only"]}`}>
                  Refresh
                </span>
              </span>
            </Button>

            <div
              // className="ms-auto"
              ref={filterAnchorRef}
              onClick={() => setFiltersPopup(!filtersPopup)}>
              {status === "Open" && !application && !department && !workType ? (
                <Button
                  className="common-btn"
                  style={{
                    width: "40px",
                    minWidth: "35px",
                    height: "40px",
                    zIndex: "100",
                  }}>
                  <FaFilter color="white" size={16} />
                </Button>
              ) : (
                <Button
                  className="common-btn px-2"
                  style={{
                    width: "40px",
                    minWidth: "35px",
                    height: "40px",
                    zIndex: "100",
                  }}>
                  <img
                    src={filtersAppliedIcon}
                    alt="Filters Applied"
                    width={25}
                    height={25}
                  />
                </Button>
              )}
            </div>

            <Button className="common-btn" onClick={() => setshowMatterForm(true)}>
              Add Matter
            </Button>
          </div>
        );

      case "myMattersPage":
        return (
          <div
            className={`d-flex align-items-center ${styles[`marginTop`]} flex-wrap`}>
            <SearchTextBox
              ref={searchRef}
              changeFilterValue={setSearchValue}
              isRefreshed={isRefreshed}
            />
            <div className="ms-3 mb-4"></div>
            <div className="me-2 filter-font">Open</div>
            <div className="mb-4 mt-2">
              <div className="nominal-form-to-parent-row">
                <div className="labels-containers">
                  <Label editorId={"dp"}>From</Label>
                  <div className="label-to">
                    <Label editorId="to">To</Label>
                  </div>
                </div>
              </div>
              <div className="nominal-form-to-row">
                <div className="date-form-to-wrapper">
                  <div className="from">
                    <div className="d-flex align-items-center justify-content-center">
                      <Checkbox
                        value={includeStartDate}
                        className="ms-3 me-1"
                        onChange={(e) => {
                          setIncludeStartDate(e.value);
                        }}
                        label={""}
                      />
                      <DatePicker
                        id="from"
                        className="date-picker"
                        value={fromDateSelector || null}
                        onChange={onChangeFromDateSelect}
                        toggleButton={CalenderCustomToggleButton}
                      />
                    </div>
                  </div>
                  <div className="divider"></div>
                  <div className="to">
                    <div className="d-flex align-items-center justify-content-center">
                      <Checkbox
                        value={includeEndDate}
                        className="ms-3 me-1"
                        onChange={(e) => {
                          setIncludeEndDate(e.value);
                        }}
                        label={""}
                      />
                      <DatePicker
                        id="to"
                        className="date-picker"
                        value={toDateSelector || null}
                        onChange={onChangeToDateSelect}
                        toggleButton={CalenderCustomToggleButton}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button
              className="ms-3 border-0 common-btn"
              onClick={handleRefresh}
              type="button"
              svgIcon={refreshIcon}>
              Refresh
            </Button>
          </div>
        );

      default:
        break;
    }
  };

  const handleCellClick = (cellProps) => {
    setSelectedCell(cellProps);
  };

  const handleContextMenu = (e, dataItem) => {
    if (dataItem.dataItem) dataItem = dataItem.dataItem;
    setSelectedCell(dataItem);
    const { status } = dataItem;
    offSet.current = { left: e.clientX, top: e.clientY };
    setShow(true);
    e.preventDefault();
  };
  const rowRender = (trElement, dataItem) => {
    const trProps = {
      ...trElement.props,
      onContextMenu: (e) => {
        e.preventDefault();
        handleContextMenu(e, dataItem.dataItem);
      },
    };

    return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
  };

  return (
    <div
      className={`${!fromClient ? "page h-100 w-100 d-flex flex-column" : "p-1"} 
                        ${component === "myMattersPage" && "mt-3"}
                    `}>
      {getHeaderItems()}
      <Grid
        {...dataState}
        data={list}
        onDataStateChange={dataStateChange}
        className="fs-md flex-grow-1 overflow-auto"
        sortable={true}
        pageable={!fromClient ? state.pageable : ""}
        pageSize={!fromClient ? state.pageSize : ""}
        resizable={true}
        rowRender={rowRender}
        showLoader={isLoading}
        loader={<GridLoader />}>
        <GridNoRecords>
          {isLoadingMattersList ? (
            <span></span>
          ) : (
            list.data && list.data.length === 0 && "No records available"
          )}
        </GridNoRecords>

        <GridColumn
          field="matterRef"
          title="Matter Ref"
          width="140px"
          cell={MatterRefCell}
        />

        <GridColumn field="details" title="Details" cell={MatterDetailCell} />

        <GridColumn
            field="officeBalance"
            title="Off Bal"
            width="80px"                  
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            className="fs-xsm p-0"
            headerClassName="grid-header-center"
        />

        <GridColumn
            field="clientBalance"
            title="Cli Bal"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            className="fs-xsm p-0"
            headerClassName="grid-header-center"
        />
        <GridColumn
            field="wipBalance"
            title="WIP"
            width="70px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            className="fs-xsm p-0"
            headerClassName="grid-header-center"
        />


        <GridColumn field="feeEarnerRef" title="FE" width="60px" />
        <GridColumn field="appCode" title="App" width="55px" />
        {fromClient && (
          <GridColumn
            field="status"
            title="Status"
            width="80px"
            cell={(props) => (
              <td>
                <span className={props.dataItem?.closed ? "text-secondary" : ""}>
                  {props.dataItem?.closed
                    ? "Closed"
                    : (props.dataItem?.status ?? "Open")}
                </span>
              </td>
            )}
          />
        )}
        <GridColumn
          field="nextReviewDate"
          title="Review Date"
          cell={DateFormatCell}
          width="117px"
        />
        <GridColumn
          field="lastActionDate"
          title="Last Used"
          cell={DateFormatCell}
          width="110px"
        />
        <GridColumn
          title=" "
          width="50px"
          cell={(props) => (
            <MatterOptions
              {...props}
              handleOptionClick={handleOptionClick}
              handleCellClick={handleCellClick}
              selectedCell={selectedCell}
              setShow={setShow}
              show={show}
            />
          )}
        />

        <GridColumn field="" title="" width="10px" />
      </Grid>
      <Popup show={show} offset={offSet.current}>
        <div tabIndex={-1} ref={menuWrapperRef}>
          <MatterOptionsList
            handleOptionClick={handleOptionClick}
            handleCellClick={handleCellClick}
            selectedCell={selectedCell}
          />
        </div>
      </Popup>

      <Popup
        key={filtersPopup ? "open" : "closed"}
        show={filtersPopup}
        anchor={filterAnchorRef.current}
        popupClass={`rounded-3 p-2`}
        anchorAlign={{ horizontal: "right", vertical: "bottom" }}
        popupAlign={{ horizontal: "right", vertical: "top" }}>
        <div
          ref={filtersPopupRef}
          className="d-flex align-items-start flex-column p-2 mx-2">
          <div className="mt-2" style={{ fontSize: "12px" }}>
            Set Filters
          </div>
          <hr className="w-100 my-1" />

          <Label className="fs-6 mt-2 mb-1">Status</Label>
          <RadioGroup
            className={`radio ${styles["statusRadioGroup"]}`}
            layout="horizontal"
            style={{ gap: "5px" }}
            data={[
              { label: "All", value: "" },
              { label: "Open", value: "Open" },
              { label: "Closed", value: "Closed" },
            ]}
            value={status}
            onChange={(e) => handleCheckboxChange(e.value)}
          />

          <div className="w-100 mt-2">
            <Label className="fw-bold d-block mb-1">Application</Label>
            <ComboBox
              loading={isLoadingApplications}
              data={activeApplications}
              textField="display"
              dataItemKey="appCode"
              value={application}
              iconClassName="wa"
              filterable
              placeholder="Select Application"
              onChange={(e) => setApplication(e.value || null)}
              style={{ width: "260px", height: "35px" }}
            />
          </div>

          <div className="w-100 mt-2">
            <Label className="fw-bold d-block mb-1">Department</Label>
            <ComboBox
              data={departmentOptions || []}
              textField="name"
              dataItemKey="departmentID"
              value={department}
              iconClassName="wa"
              filterable
              placeholder="Select Department"
              onChange={(e) => setDepartment(e.value || null)}
              style={{ width: "260px", height: "35px" }}
            />
          </div>

          <div className="w-100 mt-2">
            <Label className="fw-bold d-block mb-1">Work Type</Label>
            <ComboBox
              data={workTypeOptions || []}
              textField="name"
              dataItemKey="workTypeID"
              value={workType}
              iconClassName="wa"
              filterable
              placeholder={`${department ? "Select Work Type" : "Select Department First"}`}
              onChange={(e) => setWorkType(e.value || null)}
              style={{ width: "260px", height: "35px" }}
              disabled={!department}
            />
          </div>

          <div className="d-flex justify-content-between w-100 mt-3">
            <Button
              className="common-btn bgBtnSecondary me-2"
              onClick={handleReset}
              style={{ height: "35px" }}>
              Reset
            </Button>
            <Button
              className="common-btn "
              onClick={() => setFiltersPopup(false)}
              style={{ height: "35px" }}>
              Close
            </Button>
          </div>
        </div>
      </Popup>

      {!fromClient && (
        <HandleGridBody
          dataState={dataState}
          refresh={isRefreshed}
          onDataReceived={dataReceived}
          searchValue={searchValue}
          filterParameters={
            component === "myMattersPage" ? builtFilterParameters : filterParameters
          }
          currentComponent={component}
          status={status}
          showLoader={isLoadingMattersList}
        />
      )}

      {chitRequestModal && (
        <ChitRequest
          cancelEdit={() => {
            setChitRequestModal(false);
            dispatch(clearMattersBalances("Chit Request"));
          }}
          setModal={setChitRequestModal}
          matter={selectedMatter}
          matterId={selectedMatter?.matterId}
          component={"modal"}
          viewMode="dialog"
        />
      )}

      {timeRecordingModal && (
        <TimeRecordingHelper
          cancelEdit={() => {
            setTimeRecordingModal(false);
            dispatch(clearMattersBalances("Time Recording"));
          }}
          matter={selectedMatter}
        />
      )}

      {showMatterForm && (
        <MatterForm
          isView={reference !== undefined}
          reference={reference}
          onMatterRefClickActions={onMatterRefClickActions}
          setshowMatterForm={() => {
            setshowMatterForm(false);
            setReference(undefined);
          }}
          onMatterUpdated={handleRefresh}
        />
      )}
      {matterLedger && (
        <Dialog
          title={`Matter Ledger - ${matterLedger?.matterRef}`}
          onClose={() => selectMatterLedger()}
          className="dialog-xxl">
          <MatterLedger component={"Matter"} />
        </Dialog>
      )}

      {showBillingRequest && (
        <BillingRequestModal
          onClose={() => {
            setShowBillingRequest(false);
            setBillingRequestMatter();
          }}
          selectedMatter={billingRequestMatter}
        />
      )}
    </div>
  );
};
export default MyMattersPageComponent;
